import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { PacientService } from "src/services/pacient.service";
import { Util } from "../../../util/util";
import * as moment from "moment";
import { DocumentService } from "src/services/document.service";
import {
  LoadingController,
  ModalController,
  PopoverController,
  ToastController,
} from "@ionic/angular";
import { ModalCorVacinaComponent } from "../../modal-components/modal-cor-vacina/modal-cor-vacina-component";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";
import { ModalSelecionarCertificadoComponent } from "src/app/modal-components/modal-selecionar-certificado/modal-selecionar-certificado.component";

@Component({
  selector: "calendario-vacinas-component",
  templateUrl: "calendario-vacinas-component.html",
  styleUrls: ["./calendario-vacinas-component.scss"],
})
export class CalendarioVacinasComponent implements OnInit {
  @Output() acao = new EventEmitter();

  listaFiltroVacina: any[] = [];
  listaFiltroCNES: any[] = [];

  filtrosSelecionados: any[] = [];

  vacinasFiltradas: any[] = [];

  conteudoRevelado = false;

  vacinas: any[] = [];
  vacinasTodas: any = [];
  vacinasCovid: any = [];
  vacinasCIVP: any = [];

  tipoAcao: any = false;

  loadedData = false;

  userFiltro: any;
  vacinaDetalhe: null;
  hasCovid: any[];
  tipo = "historico";

  dtInicio: any;
  dtFim: any;

  emptyState = {
    imgUrl: "/assets/imgs/bg-vacinas.svg",
    title: "O paciente não tem nenhum registro de vacina.",
    text: "Essa área atualmente apresenta os registros de vacinação.",
  };

  constructor(
    private documentService: DocumentService,
    private paciente: PacientService,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private popoverController: PopoverController
  ) { }

  async ngOnInit() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    this.userFiltro = await this.paciente.getInfo();
    await this.getHistoricoVacinas();
    await this.formatarVacinas();

    this.vacinas = [];

    this.loadSelectFilters();

    this.formatarConteudo(false);

    this.vacinas.forEach((vac) => {
      if (!this.listaFiltroVacina.includes(vac.nome)) {
        this.listaFiltroVacina.push(vac.nome);
      }
    });

    await loading.dismiss();
  }

  ordem(lista) {

    console.log('=======vacina ordem', lista);
    return lista.sort((a, b) => {
      let oldDateFormatA = moment(a.date)
        .local()
        .format("MM-DD-YYYY HH:mm");
      let oldDateFormatB = moment(b.date)
        .local()
        .format("MM-DD-YYYY HH:mm");
      let newDateA = new Date(oldDateFormatA);
      let newDateB = new Date(oldDateFormatB);

      return Number(newDateB.getTime()) - Number(newDateA.getTime());
    })
  }

  async loadSelectFilters() {
    this.vacinasTodas.forEach((vac) => {
      vac.doses.forEach((dose) => {
        if (!this.listaFiltroCNES.includes(dose.estabelecimento)) {
          this.listaFiltroCNES.push(dose.estabelecimento);
        }
      });
    });
  }

  async formatarConteudo(hidden: boolean) {
    this.vacinas = [];
    this.vacinasTodas.forEach((vac) => {
      vac.doses.forEach((dose) => {

        let acao = 'carteira';

        if (vac.doses[0].code === "85" ||
          vac.doses[0].code === "86" ||
          vac.doses[0].code === "87" ||
          vac.doses[0].code === "88" ||
          vac.doses[0].code === "89" ||
          vac.doses[0].code === "98" ||
          vac.doses[0].code === "99" ||
          vac.doses[0].code === "102" ||
          vac.doses[0].code === "103") {
          acao = 'covid';
        }

        if (vac.doses[0].code === "14") {
          acao = 'civp';
        }

        this.vacinas.push({
          tipo: "VACINA",
          local: "",
          nome: vac.definitionName,
          date: dose.data,
          dose: dose.result,
          fabricante: dose.inst,
          lote: dose.lote,
          vacinador: dose.vacinador,
          cnes: dose.estabelecimento,
          acao
        });
      });
    });

    console.log('====this.vacinas===', this.vacinas);

    if (hidden) {
      this.vacinasFiltradas = this.vacinas.slice(0, 3);
    } else {
      this.vacinasFiltradas = this.vacinas;
    }
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    const filtro = {
      tipo,
      data,
    };

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }

    this.filter();
  }

  async getHistoricoVacinas() {
    try {
      const history: any = await this.paciente.getListClear(
        null,
        "immunizations",
        this.userFiltro.cnsPaciente
      );
      this.vacinasTodas = await this.formatVacina(history);
      this.loadedData = true;
      this.vacinasCovid = this.vacinasTodas.filter((vacina) => {
        return (
          vacina.doses[0].code === "85" ||
          vacina.doses[0].code === "86" ||
          vacina.doses[0].code === "87" ||
          vacina.doses[0].code === "88" ||
          vacina.doses[0].code === "89" ||
          vacina.doses[0].code === "98" ||
          vacina.doses[0].code === "99" ||
          vacina.doses[0].code === "102" ||
          vacina.doses[0].code === "103"
        );
      });

      console.log("=====vacinasCovid====", this.vacinasCovid);

      this.vacinasCIVP = this.vacinasTodas.filter((vacina) => {
        return vacina.doses[0].code === "14";
      });

      console.log("=====vacinasCIVP====", this.vacinasCIVP);

      this.vacinas = this.vacinasTodas.filter((vacina) => {
        return (
          vacina.doses[0].code !== "85" &&
          vacina.doses[0].code !== "86" &&
          vacina.doses[0].code !== "87" &&
          vacina.doses[0].code !== "88" &&
          vacina.doses[0].code !== "89" &&
          vacina.doses[0].code !== "98" &&
          vacina.doses[0].code !== "99" &&
          vacina.doses[0].code !== "102" &&
          vacina.doses[0].code !== "103"
        );
      });

      await this.vacinasCovid.forEach((vac) => {
        this.vacinasTodas.push(vac);
      });

      this.vacinas = await this.sortByDate(this.vacinas);
      this.vacinasTodas = await this.sortByDate(this.vacinasTodas);
      this.vacinasCovid = await this.sortByDate(this.vacinasCovid);
      this.vacinasCIVP = await this.sortByDate(this.vacinasCIVP);
    } catch (e) {
      console.error("error", e);
    }
  }

  select(data, nome) {
    this.revelarConteudo();
    if (!this.filtrosSelecionados.includes(data)) {
      this.filtrosSelecionados.push(data);
    }
    this.filter();
  }

  revelarConteudo() {
    this.conteudoRevelado = true;
    this.formatarConteudo(false);
  }

  getDosesCount(type) {
    let dosesCount = 0;
    for (let vac of type === "covid" ? this.vacinasCovid : this.vacinasCIVP) {
      dosesCount = dosesCount + vac.doses.length;
    }
    return dosesCount;
  }

  sortByDate(vacinas) {
    if (vacinas.length > 0) {
      for (const vacina of vacinas) {
        vacina.doses.sort((a, b) => {
          let oldDateFormatA = moment(a.data, "DD-MM-YYYY HH:mm")
            .local()
            .format("MM-DD-YYYY HH:mm");
          let oldDateFormatB = moment(b.data, "DD-MM-YYYY HH:mm")
            .local()
            .format("MM-DD-YYYY HH:mm");
          let newDateA = new Date(oldDateFormatA);
          let newDateB = new Date(oldDateFormatB);

          return Number(newDateB.getTime()) - Number(newDateA.getTime());
        });

        vacina.dataUltimaDose = vacina.doses[0].data;
      }

      vacinas.sort((a, b) => {
        let oldDateFormatA = moment(a.dataUltimaDose, "DD-MM-YYYY HH:mm")
          .local()
          .format("MM-DD-YYYY HH:mm");
        let oldDateFormatB = moment(b.dataUltimaDose, "DD-MM-YYYY HH:mm")
          .local()
          .format("MM-DD-YYYY HH:mm");
        let newDateA = new Date(oldDateFormatA);
        let newDateB = new Date(oldDateFormatB);

        return Number(newDateA.getTime()) - Number(newDateB.getTime());
      });
    }

    return vacinas;
  }

  async formatarVacinas() {
    for (let vacina of this.vacinasTodas) {
      for (let element of vacina.doses) {
        const detalhe: any = await this.documentService.getReadFullVacina(
          element.id + "/$document"
        );
        if (detalhe && detalhe.lote) {
          element.lote = detalhe.lote;
          element.estabelecimento = detalhe.estabelecimento;
          element.vacinador = detalhe.vacinador;
          element.instituicao = detalhe.instituicao;
        } else {
          // console.log("e", detalhe);
        }
      }
    }
  }

  getTextFormat(text) {
    return Util.getTextFormat(text);
  }

  dataFormatter(data, fmt) {
    // console.log(moment(data.dataVacinacao, 'MM-DD-YYYY').format('DD/MM/YYYY'));
    return moment(data).format(fmt);
  }

  // async detalheVacina(vacina) {
  //     this.onDetalheVacina.emit({
  //         vacina: vacina
  //     });
  // }

  formatDate(data) {
    let date = data.split("T");
    date = date[0].split("-");
    date = date[2] + "/" + date[1] + "/" + date[0];
    return date;
  }

  getInstituicao(code) {
    if (code == "85") {
      return "FIOCRUZ";
    }
    if (code == "86") {
      return "BUTATAN";
    }
    return "";
  }

  download() {
    this.documentService.downloadVacinaCarteira();
  }

  async openModalInfo() {
    const modal = await this.modalCtrl.create({
      component: ModalCorVacinaComponent,
      cssClass: "modal-cor-vacina",
      keyboardClose: true,
      componentProps: {},
    });

    modal.onDidDismiss().then((data: any) => { });

    return await modal.present();
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();
    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      console.log("called inside");
      this.vacinasFiltradas = this.vacinasFiltradas.filter((atendimento) => {
        const dtAtendimento = moment(atendimento.date);
        const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
        const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");
        return dtAtendimento.isBetween(dtInicio, dtFim);
      });
    }

    if (this.filtrosSelecionados.length) {
      const vacinasSelecionadas = this.filtrosSelecionados
        .filter((f) => f.tipo === "vacina")
        .map((f) => f.data);
      const cnesFiltro = this.filtrosSelecionados
        .filter((filter) => filter.tipo === "cnes")
        .map((filter) => filter.data);
      this.vacinasFiltradas = this.vacinasFiltradas.filter((vac) => {
        let count = 0;

        if (vacinasSelecionadas.length) {
          if (vacinasSelecionadas.includes(vac.nome)) {
            count += 1;
          }
        }
        if (cnesFiltro.length) {
          if (cnesFiltro.includes(vac.cnes)) {
            count += 1;
          }
        }
        return !!count;
      });
    }
  }

  openPlanoNacional() {
    window.open(
      "https://www.gov.br/saude/pt-br/coronavirus/vacinas/plano-nacional-de-operacionalizacao-da-vacina-contra-a-covid-19",
      "_blank"
    );
  }

  resultVacina(element) {
    if (element.definition) {
      element.fullName = element.definition.parameter.find(
        (item) => item.name === "definition"
      );
    }

    return {
      id: element.id,
      nome: element.nome,
      code: element.fab,
      definitionName: element.fullName.valueString,
      doses: [
        {
          id: element.id,
          result: element.result,
          data: element.data,
          code: element.fab,
        },
      ],
    };
  }

  async formatVacina(vacinas) {
    let result = [];
    for (const element of vacinas) {
      if (element.definition) {
        element.fullName = element.definition.parameter.find(
          (item) => item.name === "definition"
        );
      }

      if (result.length > 0) {
        let valid = false;
        result.forEach((item, index) => {
          if (element.nome == item.nome) {
            valid = true;
            result[index].doses.push({
              id: element.id,
              result: element.result,
              definition: element.definition,
              data: element.data,
              code: element.fab,
              inst: element.inst,
              definitionName: element.fullName.valueString,
            });
          }
        });
        if (!valid) {
          result.push(this.resultVacina(element));
        }
      } else {
        result.push(this.resultVacina(element));
      }
    }
    result.forEach((item, index) => {
      item.doses.forEach((element) => {
        result = this.findIndex(index, element, result);
      });
    });
    return result;
  }

  findIndex(index, element, result) {
    if (element.code == "85" || element.code == "89") {
      let qtdFio = result.filter((data) => {
        return data.doses && data.doses.find((item) => item.code == "89");
      });
      let qtdAzt = result.filter((data) => {
        return data.doses && data.doses.find((item) => item.code == "85");
      });
      if (qtdFio.length == 1 && qtdAzt.length == 1) {
        result[index]["print"] = true;
      }
    } else if (element.code == "88") {
      result[index]["print"] = true;
    }
    return result;
  }

  formatVacinaAprazadas(vacinas, history) {
    const result = history;
    vacinas.forEach((element) => {
      if (result.length > 0) {
        let valid = false;
        result.forEach((item, index) => {
          if (element.nome == item.nome) {
            valid = true;
            element.aprazamentos.forEach((doses) => {
              result[index].doses.push({
                id: doses.id,
                result: doses.esquemaDose.tipoDose.descricao,
                data: doses.dataAprazamento,
                aprazado: true,
              });
            });
          }
        });
        if (!valid) {
          result.push(this.resultVacinaAprazadas(element));
        }
      } else {
        result.push(this.resultVacinaAprazadas(element));
      }
    });
    return result;
  }

  resultVacinaAprazadas(element) {
    const vacina = {
      id: element.codigo,
      nome: element.nome,
      doses: [],
    };
    element.aprazamentos.forEach((item) => {
      vacina.doses.push({
        id: item.id,
        result: item.esquemaDose.tipoDose.descricao,
        data: item.dataAprazamento,
        aprazado: true,
      });
    });
    return vacina;
  }

  gerar(acao) {
    console.log('======passando aqui', acao);
    this.acao.emit(acao);
  }

  detalharDoc(acao) {
    this.tipoAcao = acao;
  }

  limpar() {
    this.tipoAcao = false;
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }

    await this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }


  async gerarCertificado(ev) {
    const popover = await this.popoverController.create({
      component: ModalSelecionarCertificadoComponent,
      cssClass: 'popover-seletor-certificado',
      event: ev,
      translucent: false,
      showBackdrop: false,
      componentProps: {
        covid: !!this.vacinasCovid.length,
        civp: !!this.vacinasCIVP.length,
      }
    });
    await popover.present();
    const data = await popover.onDidDismiss();
    if (data.data) {
      this.gerar(data.data)
    }
  }
}
